export default __webpack_public_path__ + "static/media/maintenance_completed.85d62d12.svg";